import type { FeatureFlags } from './types';

export const defaultFlags: FeatureFlags = {
  user_temp_dummy: false,
  dg_gift_gold: false,
  release_ncd: false,
  release_fx_buy: false,
  release_fx_sell: false,
  release_fx_send_money_abroad: false,
  release_fx_unload_card: false,
  release_fx_reload_card: false,
  release_fx_callback: false,
  release_gl_topup: false,
  release_gl_release: false,
  release_gl_location_schemes: false,
  dg_enable_card: false,
  dg_enable_netBanking: false,
  release_rv: false,
  maintenance_mode: false,
};
